import classNames from 'classnames';
import Card from '../../atoms/card';
import SVGIcon, { IIcons } from '../../atoms/icons';
import Text from '../../atoms/text';

interface InfoCardProps {
	title: string;
	value: string | number;
	icon: IIcons;
	className: string;
	iconClassName?: string;
	carregando?: boolean;
}

const InfoCard = ({
	title,
	value,
	icon,
	className,
	iconClassName,
	carregando = false,
}: InfoCardProps) => (
	<Card className={classNames('border-b-[8px] p-4', className)}>
		<Text className="font-semibold">{title}</Text>
		<div className="flex justify-between items-center">
			<Text
				aria-busy={carregando}
				className="text-[2.5rem] font-semibold"
			>
				{carregando ? (
					<span
						aria-hidden="true"
						className="inline-block h-10 w-24 rounded bg-gray-border motion-safe:animate-pulse"
					/>
				) : value}
			</Text>
			<SVGIcon
				className={classNames('w-auto', iconClassName)}
				icon={icon}
			/>
		</div>
	</Card>
);

export default InfoCard;
